import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {withStyles} from "@material-ui/core";
import BRPortfolioAddReportRequestForm from "./BRPortfolioAddReportRequestForm";
import BBIconDialogBubbles from "../../../assets/bbCustomIcons/BBIconDialogBubbles";
import {BRCustomizedTooltip} from "../accents/BRCustomizedTooltip";
import {useDispatch, useSelector} from "react-redux";
import {updateBRBusinessShare} from "../../../actions";
import {CircularProgress} from "@mui/material";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const FormDialog = (props) => {

    const {iconOnly = true, iconSize = null,
        targetCustomerId,
        targetEntityId,
        isRequestApproved = false,
        isRequestPending = false,
    } = props;
    // console.log("Dialog for adding customer to portfolio. ", targetCustomerId)

    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const {portfolios, loadingUpdateBRBusinessShare, loadingUpdateBRBusinessShareError, } = useSelector(({breachrisk}) => breachrisk);
    const {didJustCreateNewShare} = useSelector(({breachrisk}) => breachrisk.appMisc);

    const {customerInView} = useSelector(({customer}) => customer);

    const entityName = portfolios
    && targetEntityId
    && targetCustomerId
    && portfolios[targetCustomerId]
    && portfolios[targetCustomerId].entities
    && portfolios[targetCustomerId].entities[targetEntityId]
        ? portfolios[targetCustomerId].entities[targetEntityId].name
        : null;

    const currentShares = portfolios
    && targetCustomerId
    && portfolios[targetCustomerId]
        ? portfolios[targetCustomerId].shares
        : null;

    const currentShareForTargetEntity = currentShares
        && Object.values(currentShares)
        && Object.values(currentShares)
            .find((x)=> x.entity && x.entity.id && x.entity.id === targetEntityId)
    ? Object.values(currentShares)
            .find((x)=> x.entity && x.entity.id && x.entity.id === targetEntityId)
        : null;


    const shareId = currentShares
    && currentShareForTargetEntity
    && currentShareForTargetEntity.id
        ? currentShareForTargetEntity.id : null;

    // console.log(currentShareForTargetEntity, "this is the current share for", entityName)

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDeactivate = ()=>{
        dispatch(updateBRBusinessShare(targetCustomerId,
            shareId,
            "is_active",
            false,
            null))
    }

    const DialogTitle = withStyles(styles)((props) => {
        const { children, classes, onClose, ...other } = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    return (
        <div>
            <BRCustomizedTooltip title={`${isRequestApproved ? "You already have an approved sharing relationship with this entity." 
                : isRequestPending ? "A sharing request has been sent but not accepted. You may send more requests. " 
                    : "Send a sharing request to invite this company to share their BreachRisk™ Report with you. Give them access to tools to help them improve their BreachRisk™ Score."}`}
                                 heading={"Request Report Access"}
                                 >
                <Button
                    variant="outlined"
                    color="default"
                    onClick={handleClickOpen}
                    className={isRequestApproved
                        ? "text-light-gray"
                        : isRequestPending
                            ? "text-purple"
                            : "text-electric-blue"}
                    // disabled={isDisabled}
                >
                    {iconOnly
                        ? <BBIconDialogBubbles style={{fontSize: "25px"}}/>
                        : <><BBIconDialogBubbles className={"mr-2"}/>Request</>
                    }

                </Button>

            </BRCustomizedTooltip>


            <Dialog
                fullWidth={false}
                maxWidth={"sm"}
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    Request BreachRisk™ Information from {entityName}
                </DialogTitle>
                <DialogContent>

                    {!isRequestPending && !isRequestApproved &&
                        <DialogContentText>
                            {/*<p>*/}
                            {/*    Invite this company to share their BreachRisk™ Report with you and give them access to tools to help them improve their BreachRisk™ Score.*/}
                            {/*</p>*/}
                            {/*<br/>*/}
                            {/*<br/>*/}
                            <p>
                                After you submit this form, the recipient will receive an email inviting them to create a BreachRisk™ account if they don't already have one. Once their account is set up, they will then be
                                able to securely share their BreachRisk™ details with you.</p>
                        </DialogContentText>}
                    {isRequestPending &&
                    <DialogContentText>
                       <p>
                           You have already sent a request to {entityName}.
                       </p>
                        <p>
                            If you'd like to update that request, using a different Point of Contact or else request a different access level, you'll need to cancel your existing request and send a new one.
                        </p>
                        </DialogContentText>
                    }

                    {isRequestApproved &&
                        <DialogContentText>
                            <p>
                                You have already established a sharing relationship with {entityName}.
                            </p>
                            <p>
                                If you'd like to request a different level of access, you'll have to de-activate the existing relationship and send a new request with the updated access level.
                            </p>
                            For assistance or questions, please contact us at <a href={"mailto:support@breachbits.com"}>support@breachbits.com</a>
                        </DialogContentText>
                    }
                    <div className={"border-2 p-3"}>
                        {(!currentShareForTargetEntity || !currentShareForTargetEntity.is_active) &&
                            <BRPortfolioAddReportRequestForm
                            targetCustomerId={targetCustomerId}
                            targetEntityId = {targetEntityId}
                            currentShareId={shareId ? shareId : null}
                        />}

                        {currentShareForTargetEntity && currentShareForTargetEntity.is_active
                            ? <Button onClick={handleDeactivate} className={"text-center col-12"}>Deactivate Request for {entityName}</Button>
                            : (loadingUpdateBRBusinessShare[shareId] || loadingUpdateBRBusinessShareError[shareId])
                            ? <div className={"text-center p-3 m-3"}>
                                <CircularProgress/>
                            </div>
                                :null
                        }

                        {/*{shareId && !(loadingUpdateBRBusinessShare[shareId] || loadingUpdateBRBusinessShareError[shareId])*/}
                        {/*    && <div className={"text-center p-3 m-3"}>*/}
                        {/*        <CircularProgress/>*/}
                        {/*    </div>}*/}
                    </div>

                </DialogContent>
                <DialogActions>
                    {/*<Button onClick={handleClose} color="primary">*/}
                    {/*    Cancel*/}
                    {/*</Button>*/}
                    <Button onClick={handleClose} color="primary">
                        Done
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default FormDialog;
